import { render, staticRenderFns } from "./index_superiorProduct.vue?vue&type=template&id=5fd9e0d9&scoped=true"
import script from "./index_superiorProduct.vue?vue&type=script&lang=js"
export * from "./index_superiorProduct.vue?vue&type=script&lang=js"
import style0 from "./index_superiorProduct.vue?vue&type=style&index=0&id=5fd9e0d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9e0d9",
  null
  
)

export default component.exports